import { Responsive, ResponsiveGridLayoutProps, useContainerWidth } from "react-grid-layout";

type Props = Omit<ResponsiveGridLayoutProps, "width">;

export const DashboardResponsiveGrid = (props: Props) => {
  // The grid is rendered only once its container is measured, so it never lays out with a placeholder width
  const { width, containerRef, mounted } = useContainerWidth({ measureBeforeMount: true });

  return <div ref={containerRef}>{mounted && <Responsive width={width} {...props} />}</div>;
};
